import { Button,  Input, Modal, Select, Popover, Form , InputNumber, Slider,Tooltip} from "antd";
import React, { Component } from "react";
import searchIcon from "../../assets/images/searchicon.svg";
import user from "../../assets/images/user.svg";
import userColor from "../../assets/images/user_color.svg";
import gender from "../../assets/images/Gender.svg";
import calender from "../../assets/images/calender.svg";
import service from "../../assets/images/service.svg";
import token from "../../assets/images/TokenGenerator.svg";
import Patient from "../../assets/images/Patient.svg";
import networkList from "../../constants/networkList";
import postService from "../../services/httpService";
import CustomLoader from "../../components/loader";
import patientIcon from "../../assets/images/Patient.svg";
import userIcon from "../../assets/images/user_color.svg";
import Select2 from "../../components/FormComponent/select2";
import userTrackService from "../../services/usertrack-service";
import Storage from "../../services/local-store";
import moment from "moment";
import DNPatientCard from "./DNPatientCard";
import { CloseOutlined } from '@ant-design/icons';
import { ClockCircleOutlined } from '@ant-design/icons';
import { InfoCircleOutlined } from '@ant-design/icons';
import "./index.scss";
import { CheckCircleOutlined } from '@ant-design/icons';
const { confirm } = Modal;

const $ = require("jquery");
const { Option } = Select;



class DoctorAndNurse extends Component {
  constructor(props) {
    super(props);
    this.state = {
      startBilling: false,
      tokensList: [],
      filteredList: [],
      currentToken: {},
      searchVal: "",
      isLoading: false,
      modalVisible: false,
      skipReason: "",
      workstations: [],
      workstation: "",
      cabins: [],
      cabin: "",
      rooms: [],
      room: "",
      currentWorkStationDetails: "",
      currentRoomDetails: "",
      doctorViewPatientsList: [],
      workstation_id: "",
      showForm: false,
      patientId: null,
      bloodGlucoseLevelTooltipVisible: false,
      bodyTemperatureTooltipVisible: false,
      bloodPressure1TooltipVisible: false,
      bloodPressure2TooltipVisible: false,
      bloodOxygenTooltipVisible: false,
      vitalPatientDetails:[],
      bloodPressure: [0, 0],
      vitals_user_name:"",
      vitalDetails:{
          patient_id:"",
          billNumber: "",
          patientName: "",
          UMR: "",
          phoneNumber: "",
          bodyWeight: "",
          bodyTemperature: "",
          bloodGlucoseLevel: "",
          bloodPressure: "",
          bloodOxygen: "",
          vitalsCreatedTime: "",
          vitalsCaptureBy: "",
          vitals_Done:"",
          
      }
    };
  }

  renderTime(date) {
    return moment(date).format("hh:mm a");
  }

  componentDidMount() {
    const { getWorkStationsForDoctorORBillers } = networkList;
    postService(getWorkStationsForDoctorORBillers, "GET", null).then((res) => {
      if (res.status) {
        this.setState({ workstations: res.data });
      }
    });
  }

  componentDidUpdate(prevProps, prevState) {
    $(".custom-container").css({
      height:
        $(window).outerHeight() -
        ($("header").outerHeight() + $(".breadCrums").outerHeight()),
      "padding-bottom": "0px",
    });
    $(".b-card").css({
      height: $(".custom-container").outerHeight() - 30,
    });
    $(".b-card-scroll").css({
      height: $(".b-card").outerHeight(),
    });

    if (prevState.workstation !== this.state.workstation) {
      let wsDetails = this.state.workstations.filter(
        (station) => station.work_station_name === this.state.workstation
      );
      this.setState({ currentWorkStationDetails: wsDetails[0] });
    }
    if (prevState.room !== this.state.room) {
      let roomDetails = this.state.rooms.filter(
        (room) => room.room_number === this.state.room
      );
      this.setState({ currentRoomDetails: roomDetails[0] });
    }
  }
  getTokenList() {
    const { getVitalQueuePatients } = networkList;
    const { slug } = this.props.match.params;

    this.setState({ isLoading: true });

    const workstation_id = localStorage.getItem("selectWorkStationVitals");
    postService(getVitalQueuePatients, "POST", {
      data: { work_station: workstation_id },
    })
      .then((res) => {
        if (res.status) {
          // console.log("DDDDDDDDDAAAAAAAATTTTTTTTAAAAAAAa",res.data);
          this.setState(prevState => ({
            vitalDetails: {
              ...prevState.vitalDetails, // Keep existing details
                vitalsCaptureBy:  res.user}
          }));
          this.setState({ tokensList: res.data, isLoading: false,vitals_user_name: res.user });
        } else {
          this.setState({ tokensList: [], isLoading: false });
        }
      })
      .catch((err) => {
        this.setState({ isLoading: false });
     
      });
    
    }
  assignTokenToBiller() {
    const { AssignTokenToBiller } = networkList;
    const { slug } = this.props.match.params;

    if (slug === "biller-view") {
      postService(AssignTokenToBiller, "POST", {
        data: {
          unitid: this.state.currentWorkStationDetails["unit_id"],
          work_station_id: this.state.currentWorkStationDetails["id"],
        },
      })
        .then((res) => {
          if (res.status) {
            this.setState({ currentToken: res.data });
          }else {
            Modal.error({
              title: "Error!",
              content: "Something went wrong.",
            })
          }
        })
        .catch((err) => console.log("AssignTokenToBiller err", err));
    }
  }
  assignNextTokenToBiller() {
    const { AssignNextTokenToBiller } = networkList;
    const { slug } = this.props.match.params;

    if (slug === "biller-view") {
      postService(AssignNextTokenToBiller, "POST", {
        data: {
          unitid: this.state.currentWorkStationDetails["unit_id"],
          work_station_id: this.state.currentWorkStationDetails["id"],
        },
      }).then((res) => {
      
        if (res.status) {
          this.setState({ currentToken: res.data });
        } else {
          this.setState({ currentToken: "" });
          Modal.error({
            title: "Notice!",
            content: "There are no Patients in the queue!",
            onOk: function () {
              window.scrollTo(0, 0);
            },
          });
        }
      });
    }
  }
  handleSliderChange = () => {
    this.setState({ bloodGlucoseLevelTooltipVisible: true });
  };

  handleAfterChange = () => {
    this.setState({ bloodGlucoseLevelTooltipVisible: true });
  };
  bohandleSliderChange = () => {
    this.setState({ bloodOxygenTooltipVisible: true });
  };

  bohandleAfterChange = () => {
    this.setState({ bloodOxygenTooltipVisible: true });
  };
  bp1handleSliderChange = (value) => {
    this.setState({ bloodPressure: [value, this.state.bloodPressure[1]] });
    this.setState({ bloodPressure1TooltipVisible: true });
  };

  bp2handleSliderChange = (value) => {
    this.setState({ bloodPressure: [this.state.bloodPressure[0], value] });
    this.setState({ bloodPressure2TooltipVisible: true });
  };
  // bp1handleSliderChange = () => {
  //   this.setState({ bloodPressure1TooltipVisible: true });
  // };

  bp1handleAfterChange = () => {
    this.setState({ bloodPressure1TooltipVisible: true });
  };
  // bp2handleSliderChange = () => {
  //   this.setState({ bloodPressure2TooltipVisible: true });
  // };

  bp2handleAfterChange = () => {
    this.setState({ bloodPressure2TooltipVisible: true });
  };
  bthandleSliderChange = () => {
    this.setState({ bodyTemperatureTooltipVisible: true });
  };

  bthandleAfterChange = () => {
    this.setState({ bodyTemperatureTooltipVisible: true });
  };
  onStartBilling() {
    this.setState({ startBilling: true });
    this.getTokenList();
    this.assignTokenToBiller();
  }
  getSearchResults(event) {
    let value = event.target.value;
    this.setState({ searchVal: value });

    let filteredList = this.state.tokensList.filter(
      (item) =>
        (item.patient_name &&
          item.patient_name.toLowerCase().includes(value.toLowerCase())) ||
        (item.phone_number && item.phone_number.includes(value))
    );
    this.setState({ filteredList });
  }

  setModalVisible(modalVisible) {
    this.setState((state) => ({
      modalVisible: modalVisible,
    }));
  }
  handleFormInputChange() {}
  selectReason(value) {
    this.setState({ skipReason: value });
  }
  selectWorkstation(event) {
    const { slug } = this.props.match.params;

   localStorage.setItem("selectWorkStationVitals", event);
    this.setState({ workstation_id: event });

    let wsDetails = this.state.workstations.filter(
      (station) => station.work_station_name === event
    );
  }
  refreshCard = () => {
    this.getTokenList();
    this.renderBody();
  };

  queueCol(list) {
    const { slug } = this.props.match.params;
    let that = this;
    return (
      <div className="col-3 col-md-5 col-lg-3">
        <div className="card b-card">
          <span class="PatientsTitle">{`Patients (${
            list && list.length
          })`}</span>
          <div className="row mb-3">
            <div className="col-9 pr-0">
              <Input
                placeholder="Search here"
                value={this.state.searchVal}
                allowClear={true}
                onChange={(e) => this.getSearchResults(e)}
              />
            </div>
            <div className="col-1 mr-1">
              <img
                src={searchIcon}
                alt=""
                className="biller-search-icon-img operatorSearchicon"
              />
            </div>
            <div className="col-1 text-right pt-1">
              <Popover
                overlayClassName="popover-custom"
                placement="top"
                title={""}
                content={"Refresh"}
              >
                <figure
                  className="my-auto mx-1"
                  onClick={this.refreshCard.bind(this)}
                >
                  <img src="/assets/images/icons/refresh.png" alt="refresh" />
                </figure>
              </Popover>
            </div>
          </div>
          <div className="b-card-scroll mb-3">
            {list &&
              list.map((item) => (
             
                <React.Fragment>
                    
                  <div className="py-1 pl-4 pr-1 mr-1 mt-2 b-card-body disable-text">
                    {/* Patientname */}
                    <div className="row ">
                      <div>
                        <img
                          alt=""
                          src={patientIcon}
                          className="patientIcon ml-0 mr-1"
                        />

                        <span className="Patientname">
                          {item && item.name ? item.name : "--"}
                        </span>
                      </div>
                    </div>
                    {/* phone - status */}
                    <div className="row mt-1 displaySpaceBetween">
                      <div>
                        {/* <Icon
                          type="info-circle"
                          style={{
                            color: "#ac7ab0",
                            transform: "rotate(0deg)",
                            fontSize: "17px",
                            margin: "0 6px 0 -2px",
                          }}
                          // draggable={draggableStatus}
                        /> */}
                        

<InfoCircleOutlined
  style={{
    // color: '#ac7ab0',
    color: '#ac7ab0',
    transform: 'rotate(0deg)',
    fontSize: '17px',
    margin: '0 6px 0 -2px',
  }}
  // draggable={draggableStatus}
/>

                        <span className="Patientname">
                          {item.umr ? item.umr : "--"}
                        </span>
                      </div>
                      <div>
                        <span
                          class="buttonVitals pointer"
                          // onClick={this.vitals.bind(this, item, that)}
                          onClick={() => this.handleVitals(item.id,item)}
                        >
                          VITALS
                        </span>
                      </div>
                    </div>
                    <div className="row">
                      <div>
                        <img
                          alt=""
                          src={userIcon}
                          className="uidIcon"
                          // draggable={draggableStatus}
                        />

                        <span className="Patientname">
                          {item.service_name ? item.service_name : "--"}
                        </span>
                      </div>
                    </div>
                    <div className="row pr-3 mt-1 displaySpaceBetween">
                      <div>
                        <img
                          alt=""
                          src={service}
                          // draggable={draggableStatus}
                          className="uidIcon"
                        />
                        <span className="Patientname">
                          {item.patienttype ? item.patienttype : "--"}
                        </span>
                      </div>
                      <div className="tPatientname">
                        <div>
                          {/* <Icon
                            type="clock-circle"
                            style={{
                              color: "#ac7ab0",
                              transform: "rotate(0deg)",
                              fontSize: "17px",
                              margin: "0 6px 0 0",
                            }}
                          /> */}
                         

<ClockCircleOutlined
  style={{
    color: '#ac7ab0',
    transform: 'rotate(0deg)',
    fontSize: '17px',
    margin: '0 6px 0 0',
  }}
/>

                        </div>
                        <div className="mt-1">
                          {item.appointment_date
                            ? this.renderTime(item.appointment_date)
                            : "--"}
                        </div>
                      </div>
                    </div>
                  </div>
                </React.Fragment>
              ))}
          </div>
        </div>
      </div>
    );
  }
  billerCurrPatientDetailsCol(list) {
    let { currentToken } = this.state;
    let options = ["Patient Request", "Doctor Request", "Other reason"];

    return (
      <div className="col-9 col-md-7 col-lg-9">
        <div className="card b-card p-2 px-3">
          {list.length ? (
            <>
              <span class="row Token-Generation">Current Patient Details</span>
              <div className="row">
                <div className="col-5">
                  <div className="billerPatientDetails">
                    <div className="row pl-3 mb-2">
                      <div class="patientNameIcon">
                        <img
                          src={user}
                          alt=""
                          className="patientNameIconImage"
                        />
                      </div>
                      <span className="col patientNamedetails">
                        <span className="row text-style-1">Name</span>
                        <span className="row">{currentToken.patient_name}</span>
                      </span>
                    </div>
                    <div className="row pl-3 mb-2">
                      <div className="patientGenderIcon">
                        <img
                          src={gender}
                          alt=""
                          className="patientGenderIconImage"
                        />
                      </div>
                      <span className="patientGender">
                        Gender
                        <span className="row pl-3 text-style-1">
                          {currentToken.gender}
                        </span>
                      </span>
                    </div>
                    <div className="row pl-3">
                      <div className="patientageIcon">
                        <img
                          src={calender}
                          alt=""
                          className="patientageIconImage"
                        />
                      </div>
                      <span className="patientAge">
                        <span className="row pl-3 text-style-1">Age</span>
                        {/* 27 Yrs, 3 Months, 20 Days */}
                        {currentToken.age}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="col-7">
                  <div className="row uidcard">
                    <img src={userColor} alt="" className="uidcardIcon" />
                    <div className="LineCopy">
                      <span className="row UID-no">
                        <span className="text-style-1">UID</span>
                        {/* {currentToken.umr} */}
                        {currentToken.phone_number}
                      </span>
                    </div>
                  </div>
                  <div className="row tokenCard">
                    <img src={token} alt="" className="tokenCardIcon" />
                    <div className="LineCopy">
                      <span className="row Token-No">
                        Token No
                        <span className="text-style-1">
                          {currentToken.token_display_id}
                        </span>
                      </span>
                    </div>
                  </div>
                  <div className="row serviceCard">
                    <img src={service} alt="" className="serviceCardimg" />
                    <div className="LineCopy">
                      <span className="row Service-Name-Billing">
                        Service Name
                        <span className="text-style-1">
                          {" "}
                          {currentToken.service_name}
                        </span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <Button
                  className="Chekoutandnext"
                  onClick={this.onCheckout.bind(this)}
                >
                  <span className="">CheckOut & Next</span>
                </Button>
                <Button
                  className="Skipandnext"
                  onClick={this.onSkip.bind(this)}
                >
                  <span className="">Skip & Next</span>
                </Button>
              </div>

              <Modal
                centered
                footer={null}
                maskClosable={false}
                visible={this.state.modalVisible}
                onOk={() => this.setModalVisible(false)}
                onCancel={() => this.setModalVisible(false)}
              >
                <div className="row">
                  <button
                    type="button"
                    class="btn"
                    onClick={() => this.setModalVisible(false)}
                  >
                    {/* <Icon type="close" className="popup-close" /> */}
                    

                    <CloseOutlined className="popup-close" />

                  </button>
                  <div className="col-12 position-relative form-block py-4">
                    <form noValidate>
                      <div className="row mb-4">
                        <div className="col-12 mx-auto">
                          <h2 className="text-center">Choose reason to skip</h2>
                        </div>
                      </div>
                      <div className="row mb-5">
                        <div className="col-8 w-100 mx-auto">
                          {/* <Select2
                selectdata={feild}
                {...this.props}
                {...this.state}
                Queuedata={this.state.formData}
                onselectChanges={this.handleFormInputChange.bind(
                  this
                )}
              /> */}
                          <Select
                            placeholder="Select the reason"
                            onChange={this.selectReason.bind(this)}
                          >
                            {options.map((option, key) => (
                              <Option key={key} value={option}>
                                {option}
                              </Option>
                            ))}
                          </Select>
                        </div>
                      </div>
                      <div className="row mb-4">
                        <div className="col-12 text-center">
                          <Button
                            className="btn-magenta pt-1 px-5"
                            onClick={this.onSkipReason.bind(this)}
                          >
                            Ok
                          </Button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </Modal>
            </>
          ) : (
            <div className="my-5 py-5">
              <h5 className="text-center">
                There are No Patients in the Queue!
              </h5>
            </div>
          )}
        </div>
      </div>
    );
  }
  billerWelcomeScreen() {
    const { slug } = this.props.match.params;
    let { workstations, workstation, cabins, cabin, rooms, room } = this.state;
    return (
      <div className="col StartTG">
        <h5>Welcome!</h5>
        {/* <h6>Patients are waiting in the queue.</h6> */}
        <h6>Click to start Queue.</h6>
        <Select
          id="location"
          placeholder="Select Location"
          style={{ width: 240 }}
          onChange={this.selectWorkstation.bind(this)}
          defaultValue={localStorage.getItem("selectWorkStationVitals")}
        >
          {console.log(
            "selectWorkStationVitals",
            localStorage.getItem("selectWorkStationVitals")
          )}
          {workstations.map((station) =>
            localStorage.getItem("selectWorkStationVitals") ? (
              <Option value={station.id} key={station.id}>
                {station.work_station_name}
              </Option>
            ) : (
              <Option value={station.id} key={station.id}>
                {station.work_station_name}
              </Option>
            )
          )}
        </Select>
        <Button
          className="TGStartBtn btn-magenta mt-5"
          size="large"
          onClick={this.onStartBilling.bind(this)}
        >
          Start Queue! 
        </Button>
      </div>
    );
  }
  doctorCurrPatientDetailsCol(list) {
    let { currentToken, doctorViewPatientsList } = this.state;
    let options = ["Patient Request", "Doctor Request", "Other reason"];
   
    return (
      <div className="col-9 col-md-7 col-lg-9">
        <div className="card b-card px-4 py-2">
          <span className="row Current-Patient-title">
            Current Patient Details
          </span>
          <div className="row my-4">
            <div className="col-5">
              <div className="PatientDetails">
                <div className="row pl-3">
                  <div class="col-2 patientNameIcon">
                    <img src={user} alt="" className="patientNameIconImage" />
                  </div>
                  <span class="col patientNamedetails">
                    <span class="row text-style-1">Name</span>
                    <span className="row">
                      {doctorViewPatientsList &&
                        doctorViewPatientsList[0] &&
                        doctorViewPatientsList[0]["name"]}
                    </span>
                  </span>
                </div>
                <div className="row pl-3">
                  <div class="patientGenderIcon">
                    <img
                      src={gender}
                      alt=""
                      className="patientGenderIconImage"
                    />
                  </div>
                  <span class="patientGender">
                    Gender
                    <span class="row pl-3 text-style-1">--</span>
                  </span>
                </div>
                <div className="row pl-3">
                  <div class="patientageIcon">
                    <img
                      src={calender}
                      alt=""
                      className="patientageIconImage"
                    />
                  </div>
                  <span class="patientAge">
                    <span class="row pl-3 text-style-1">Age</span>
                    {/* 27 Yrs, 3 Months, 20 Days */} --
                  </span>
                </div>
              </div>
            </div>
            <div className="col-3 mx-2">
              <div className="row DNuidcard">
                <img src={Patient} alt="" class="PatientIcon" />
                <div class="LineCopy">
                  <span class="row UID-no">
                    <span class="text-style-1">Phone</span>
                    {/* Patient12 */}{" "}
                    {doctorViewPatientsList &&
                      doctorViewPatientsList[0] &&
                      doctorViewPatientsList[0]["phonenumber"]}
                  </span>
                </div>
              </div>
              <div className="row DNtokenCard">
                <img src={token} alt="" class="tokenCardIcon" />
                <div class="LineCopy">
                  <span class="row Token-No">
                    Appt Time
                    {/* <span class="text-style-1">12:30PM</span> */}
                    <span class="text-style-1">
                      {" "}
                      {doctorViewPatientsList &&
                        doctorViewPatientsList[0] &&
                        doctorViewPatientsList[0]["appointment_date"] &&
                        this.renderTime(
                          doctorViewPatientsList[0]["appointment_date"]
                        )}
                    </span>
                  </span>
                </div>
              </div>
              <div className="row DNserviceCard">
                <img src={service} alt="" class="serviceCardimg" />
                <div class="LineCopy">
                  <span class="row Service-Name-Billing">
                    Speciality
                    <span class="text-style-1">Cardiology</span>
                    {/* <span class="text-style-1">--</span> */}
                  </span>
                </div>
              </div>
            </div>
            <div className="col-3 ml-4">
              <div className="row DNuidcard">
                <img src={userColor} alt="" class="uidcardIcon" />
                <div class="LineCopy">
                  <span class="row UID-no">
                    <span class="text-style-1">UID</span>
                    {doctorViewPatientsList &&
                      doctorViewPatientsList[0] &&
                      doctorViewPatientsList[0]["umr"]}
                  </span>
                </div>
              </div>
              <div className="row DNtokenCard">
                <img src={token} alt="" class="tokenCardIcon" />
                <div class="LineCopy">
                  <span class="row Token-No">
                    Service Name
                    {/* <span class="text-style-1">OPD Consulting</span> */}
                    {/* <span class="text-style-1">--</span> */}
                    <span class="text-style-1">
                      {doctorViewPatientsList &&
                        doctorViewPatientsList[0] &&
                        doctorViewPatientsList[0]["bill_service_group"]}
                    </span>
                  </span>
                </div>
              </div>
              <div className="row DNserviceCard">
                <img src={service} alt="" class="serviceCardimg" />
                <div class="LineCopy">
                  <span class="row Service-Name-Billing">
                    Consultation Mode
                    <span class="text-style-1">Online</span>
                    {/* <span class="text-style-1"> --</span> */}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <Button className="Chekoutandnext">
              <span>CheckOut & Next</span>
            </Button>
            <Button className="Skipandnext" onClick={this.onSkip.bind(this)}>
              <span>Skip & Next</span>
            </Button>
          </div>
          <Modal
            centered
            footer={null}
            maskClosable={false}
            visible={this.state.modalVisible}
            onOk={() => this.setModalVisible(false)}
            onCancel={() => this.setModalVisible(false)}
          >
            <div className="row">
              <button
                type="button"
                class="btn"
                onClick={() => this.setModalVisible(false)}
              >
                {/* <Icon type="close" className="popup-close" /> */}
               

<CloseOutlined className="popup-close" />

              </button>
              <div className="col-12 position-relative form-block py-4">
                <form noValidate>
                  <div className="row mb-4">
                    <div className="col-12 mx-auto">
                      <h2 className="text-center">Choose reason to skip</h2>
                    </div>
                  </div>
                  <div className="row mb-5">
                    <div className="col-8 w-100 mx-auto">
                      <Select
                        placeholder="Select the reason"
                        onChange={this.selectReason.bind(this)}
                      >
                        {options.map((option, key) => (
                          <Option key={key} value={option}>
                            {option}
                          </Option>
                        ))}
                      </Select>
                    </div>
                  </div>
                  <div className="row mb-4">
                    <div className="col-12 text-center">
                      <Button
                        className="btn-magenta pt-1 px-5"
                        onClick={this.onSkipReason.bind(this)}
                      >
                        Ok
                      </Button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </Modal>
        </div>
      </div>
    );
  }
  renderBody() {
    const { slug } = this.props.match.params;
    let {
      startBilling,
      tokensList,
      searchVal,
      filteredList,
      isLoading,
      doctorViewPatientsList,
    } = this.state;
    let billerPatientlist = searchVal ? filteredList : tokensList;
    let doctorviewPatientlist = doctorViewPatientsList;
console.log("TOKEN LIST",tokensList);
    if (slug === "vitals-view") {
      return (
        <>
          {startBilling ? (
            <>
              {isLoading && <CustomLoader />}
              {this.queueCol(billerPatientlist)}
              {/* {this.billerCurrPatientDetailsCol([])} */}
            </>
          ) : (
            this.billerWelcomeScreen()
          )}
        </>
      );
    }
  }
  handleVitals = (id,item) => {
    this.setState({ patientId: id, showForm: true,vitalPatientDetails:item });
    this.setState(prevState => ({
      vitalDetails: {
        ...prevState.vitalDetails, // Keep existing details
        billNumber: item.billnumber,
          patientName:item.name,
          UMR: item.umr,
          phoneNumber:item.phonenumber,
          patient_id:id.toString(),
          vitalsCaptureBy:this.state.vitals_user_name ,
          
        
      },
      bloodGlucoseLevelTooltipVisible: false,
      bodyTemperatureTooltipVisible: false,
      bloodPressure1TooltipVisible: false,
      bloodPressure2TooltipVisible: false,
      bloodOxygenTooltipVisible: false,
      bloodPressure:[0,0],

    }));
  };
  onFinish = (values) => {
  

    const now = moment().format('YYYY-MM-DD HH:mm:ss');
    let formattedWeight = values.bodyWeight.toString() + " Kgs";
    let formattedTemperature = values.bodyTemperature.toString() + "°F";
    let formattedbloodGlucoseLevel = values.bloodGlucoseLevel.toString() + " mg/dL";
    let formattedbloodOxygen = values.bloodOxygen.toString() + "%";
    let formattedString = `${this.state.bloodPressure[0]}/${this.state.bloodPressure[1]}`;
this.setState(prevState => ({
  vitalDetails: {
    ...prevState.vitalDetails, // Keep existing details
    
    bodyWeight: formattedWeight,
    bodyTemperature:formattedTemperature,
    bloodGlucoseLevel: formattedbloodGlucoseLevel,
    bloodPressure: formattedString,
    bloodOxygen: formattedbloodOxygen,
    vitalsCreatedTime: now,
    
  }
}));
this.setState(prevState => ({
  vitalDetails: {
    ...prevState.vitalDetails, // Keep existing details
    
   
    vitals_Done: "YES",
    
  }
}));
    // Perform your logic here with the form values
console.log("FINAL DATA",this.state.vitalDetails);

let vital_details=this.state.vitalDetails;
let v_status=null;
confirm({
title: (
  <>
    <CheckCircleOutlined style={{ color: '#52c41a', marginRight: 8 }} />
    Vitals submitted successfully
  </>
),
icon: null,
content: "",
okText: "OK",
cancelButtonProps: { style: { display: 'none' } },
onOk() {


        let patient_id = vital_details.patient_id || "";
        if (patient_id !== undefined && patient_id !== null) {
        
          let obj = vital_details;
       
          let Userlogobj = {
            user: JSON.parse(Storage.get("user")),
            action: "set Patient Vitals DoneFlag- Request",
            date: new Date(),
            meta: obj,
          };
          userTrackService(Userlogobj);

          postService("setPatientVitalsDoneFlag", "POST", { data: obj }).then(
            (res) => {
              let Userlogobjres = {
                user: JSON.parse(Storage.get("user")),
                action: "restore queue - response",
                date: new Date(),
                meta: res,
              };
              v_status=res.status;
            
              userTrackService(Userlogobjres);
              })
            }}
           
            })
            if (v_status) {
              this.getTokenList();
              this.renderBody();

              //that.refreshQueueListData();
            }
  //           }
  //         );
  //       }
  //     },
  //     onCancel() {
  //       console.log("Cancel");
  //     },
     
     
  //   });
    this.setState({ showForm: false });
  };

  onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };
  // vitals(data, that) {
  //   confirm({
  //     title: "Vitals are captured for this patient?",
  //     content: "",
  //     okText:"YES",
  //     cancelText:"NO",
  //     onOk() {
  //       let patient_id = data.id || "";
  //       if (patient_id !== undefined && patient_id !== null) {
  //         console.log("OK");
  //         let obj = {
  //           patient_id: patient_id,
  //           is_vitals_done: "YES",
  //         };
  //         console.log(obj);
  //         let Userlogobj = {
  //           user: JSON.parse(Storage.get("user")),
  //           action: "set Patient Vitals DoneFlag- Request",
  //           date: new Date(),
  //           meta: obj,
  //         };
  //         userTrackService(Userlogobj);
  //         postService("setPatientVitalsDoneFlag", "POST", { data: obj }).then(
  //           (res) => {
  //             let Userlogobjres = {
  //               user: JSON.parse(Storage.get("user")),
  //               action: "restore queue - response",
  //               date: new Date(),
  //               meta: res,
  //             };
  //             userTrackService(Userlogobjres);
  //             if (res.status) {
  //               that.getTokenList();
  //               that.renderBody();

  //               //that.refreshQueueListData();
  //             }
  //           }
  //         );
  //       }
  //     },
  //     onCancel() {
  //       console.log("Cancel");
  //     },
     
     
  //   });
  // }
  render() {
  
    return (
      <div>
         
      {this.state.showForm && (
        <Modal
          title="VITALS"
          visible={this.state.showForm}
          onCancel={() => this.setState({ showForm: false })}
          footer={null}
          style={{textAlign:"center",}}
          className="vitals-header"
        >
        <div class="row" style={{paddingBottom:"10px",paddingTop:"15px"}}>
          <div class="col">
          <Tooltip title="Patient Name" color='#6c3964' key='white'>
          <p> {this.state.vitalPatientDetails.name}</p>
        </Tooltip>
         
          </div>
          <div class="col">
          <Tooltip title="Patient UMR" color='#6c3964' key='white'>
          <p>{this.state.vitalPatientDetails.umr} </p>
        </Tooltip>

          </div>
          <div class="col">
          <Tooltip title="Patient Bill Number" color='#6c3964' key='white'>
          <p>{  this.state.vitalPatientDetails.billnumber} </p>
        </Tooltip>

          </div>
        

         </div>
          <Form
            name="vitalsForm"
            initialValues={{ patient_id: this.state.patientId,billnumber:this.state.vitalPatientDetails.billnumber,umr:this.state.vitalPatientDetails.umr,name:this.state.vitalPatientDetails.name,phonenumber:this.state.vitalPatientDetails.phonenumber }}
            onFinish={this.onFinish}
            onFinishFailed={this.onFinishFailed}
            style={{padding:"0px 0px"}}
          >
            {/* <Form.Item
              label="Patient ID"
              name="patient_id"
              rules={[{ required: true, message: 'Please input the patient ID!' }]}
            >
              <Input disabled style={{width:"83%", marginLeft:"65px"}}/>
            </Form.Item>
            <Form.Item
              label="Patient Name"
              name="name"
              rules={[{ required: true, message: 'Please input the patient ID!' }]}
            >
              <Input disabled style={{width:"88%", marginLeft:"42px"}}/>
              
            </Form.Item>
            <Form.Item
              label="Bill Number"
              name="billnumber"
              rules={[{ required: true, message: 'Please input the patient ID!' }]}
              
            >
              <Input disabled style={{width:"85%", marginLeft:"55px"}} />
            </Form.Item>
            <Form.Item
              label="UMR"
              name="umr"
              rules={[{ required: true, message: 'Please input the patient ID!' }]}
            >
              <Input disabled style={{width:"77%", marginLeft:"95px"}}/>
            </Form.Item>
           
          
            <Form.Item
              label="Phone Number"
              name="phonenumber"
              rules={[{ required: true, message: 'Please input the patient ID!' }]}
            >
              <Input disabled style={{width:"90.5%", marginLeft:"34px"}} />
            </Form.Item> */}
             <Form.Item
                label="Body Weight"
                name="bodyWeight"
                rules={[
                  { required: true, message: 'Please input the body temperature!' },
                  { pattern: /^[0-9]+$/, message: 'Please enter only numbers!' } // Add this rule
                ]}
                
             
              >
                <Input  style={{width:"86%", marginLeft:"45px",forntSize:"10px" ,height:"30px"}}size="large"/>
              </Form.Item>
              {/* <Form.Item
  label="Body Temperature"
  name="bodyTemperature"
  rules={[{ required: true, message: 'Please input the body temperature!' }]}
  style={{ paddingTop: "10px" }}
>
  <InputNumber
    style={{ width: "60%", marginLeft: "2px" }}
    min={95}
    max={105}
    step={0.1}
  />
</Form.Item> */}
<Form.Item
  label="Body Temperature"
  name="bodyTemperature"
  rules={[{ required: true, message: 'Please input the body temperature!' }]}
 >
  <Slider
    min={95}
    max={105}
    step={0.1}
    marks={{ 95: '95', 105: '105' }}
     tooltipVisible={this.state.bodyTemperatureTooltipVisible}
     tipFormatter={(value) => `${value} °F`}
    onChange={this.bthandleSliderChange}
    onAfterChange={this.bthandleAfterChange}
    trackStyle={{ backgroundColor: '#6c3964' }}
    style={{ marginLeft:"16px", width:"93%"}}
    activeDotStyle={{ borderColor: '#6c3964' }}
   
    className="custom-slider"
   
  />
</Form.Item>
<Form.Item
  label="Blood Glucose Level"
  name="bloodGlucoseLevel"
  rules={[{ required: true, message: 'Please input the blood glucose level!' }]}
>
  <Slider
    min={70}
    max={200}
    step={1}
    marks={{ 70: '70', 200: '200' }}
    tooltipVisible={this.state.bloodGlucoseLevelTooltipVisible}
    tipFormatter={(value) => `${value} mg/dL`}
    onChange={this.handleSliderChange}
    onAfterChange={this.handleAfterChange}
    trackStyle={{ backgroundColor: '#6c3964' }}   // Track color
    activeDotStyle={{ borderColor: '#6c3964' }}
  
   
    // tooltipVisible
    // tipFormatter={(value) => `${value} mg/dL`}
  />
</Form.Item>

{/* 
              <Form.Item
                label="Blood Glucose Level"
                name="bloodGlucoseLevel"
                rules={[{ required: true, message: 'Please input the blood glucose level!' }]}
              >
                <Input />
              </Form.Item> */}


{/*<Form.Item
  label="Blood Pressure"
  name="bloodPressure"
  // rules={[{ required: true, message: 'Please input the blood pressure!' }]}
  rules={[
    {
      validator: (_, value) => {
        if (value && (value[0] || value[1])) {
          return Promise.resolve();
        }
        return Promise.reject('Please input the blood pressure!');
      },
    },
  ]}
>
  <div style={{ display: 'flex', alignItems: 'center' }}>
    <Slider
      style={{ flex: 1, marginRight: 10 }}
      min={80}
      max={200}
      step={1}
      marks={{ 80: '80', 200: '200' }}
      tipFormatter={(value) => `${value}`}
    onChange={this.bp1handleSliderChange}
    onAfterChange={this.bp1handleAfterChange}
    trackStyle={{ backgroundColor: '#6c3964' }} 
    tooltipVisible={this.state.bloodPressure1TooltipVisible}
    activeDotStyle={{ borderColor: '#6c3964' }}
      
    />
    <span style={{marginBottom:"25px"}}>/</span>
    <Slider
      style={{ flex: 1, marginLeft: 10 }}
      min={40}
      max={150}
      step={1}
      marks={{ 40: '40', 150: '150' }}
      tipFormatter={(value) => `${value}`}
      onChange={this.bp2handleSliderChange}
      onAfterChange={this.bp2handleAfterChange}
      trackStyle={{ backgroundColor: '#6c3964' }} 
      tooltipVisible={this.state.bloodPressure2TooltipVisible}
      activeDotStyle={{ borderColor: '#6c3964' }}
      className="ant-slider-tooltip"
    />
  </div>
</Form.Item> */}
{/* <Form.Item
  label="Blood Pressure"
  name="bloodPressure"
  rules={[
    {
      validator: (_, values) => {
        if (console.log("BLood Pressure Value ",values) && values  && (values[0] !== undefined || values[1] !== undefined)) {
          return Promise.resolve();
        }
        return Promise.reject('Please input the blood pressure!');
      },
    },
  ]}
>
  <div style={{ display: 'flex', alignItems: 'center' }}>
    <Slider
      style={{ flex: 1, marginRight: 10 }}
      min={80}
      max={200}
      step={1}
      marks={{ 80: '80', 200: '200' }}
      tipFormatter={(value) => `${value}`}
      onChange={this.bp1handleSliderChange}
      onAfterChange={this.bp1handleAfterChange}
      trackStyle={{ backgroundColor: '#6c3964' }}
      tooltipVisible={this.state.bloodPressure1TooltipVisible}
      activeDotStyle={{ borderColor: '#6c3964' }}
    />
    <span style={{ marginBottom: "25px" }}>/</span>
    <Slider
      style={{ flex: 1, marginLeft: 10 }}
      min={40}
      max={150}
      step={1}
      marks={{ 40: '40', 150: '150' }}
      tipFormatter={(value) => `${value}`}
      onChange={this.bp2handleSliderChange}
      onAfterChange={this.bp2handleAfterChange}
      trackStyle={{ backgroundColor: '#6c3964' }}
      tooltipVisible={this.state.bloodPressure2TooltipVisible}
      activeDotStyle={{ borderColor: '#6c3964' }}
      className="ant-slider-tooltip"
    />
  </div>
</Form.Item> */}
  <Form.Item
        label="Blood Oxygen"
        name="bloodOxygen"
        rules={[{ required: true, message: 'Please input the blood oxygen level!' }]}
      >
        <Slider
          min={0}
          max={100}
          marks={{ 0: '0', 25: '25', 50: '50', 75: '75', 100: '100' }}
          tipFormatter={(value) => `${value}%`}
          style={{ marginLeft: 45, width: '86%' }}
          tooltipVisible={this.state.bloodOxygenTooltipVisible}
    onChange={this.bohandleSliderChange}
    onAfterChange={this.bohandleAfterChange}
    trackStyle={{ backgroundColor: '#6c3964' }}
    activeDotStyle={{ borderColor: '#6c3964' }} 
        />
      </Form.Item>
<Form.Item
          label="Blood Pressure"
          name="bloodPressure"
          rules={[
            {required:true,
              validator: (_, values) => {
                if ( (this.state.bloodPressure[0] !== undefined && this.state.bloodPressure[1] !== undefined)&& this.state.bloodPressure[0] !== 0 && this.state.bloodPressure[1] !== 0) {
                  return Promise.resolve();
                }
                else{
                return Promise.reject('Please input the blood pressure!');}
              },
            },
          ]}
        >
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Slider
              style={{ flex: 1, marginRight: 10 }}
              min={80}
              max={200}
              step={1}
              marks={{ 80: '80', 200: '200' }}
              tipFormatter={(value) => `${value}`}
              onChange={this.bp1handleSliderChange}
              onAfterChange={this.bp1handleAfterChange}
              value={this.state.bloodPressure[0]}
              trackStyle={{ backgroundColor: '#6c3964' }}
              activeDotStyle={{ borderColor: '#6c3964' }}
              tooltipVisible={this.state.bloodPressure1TooltipVisible}
            />
    
            <span style={{ marginBottom: '25px' }}>/</span>
            <Slider
              style={{ flex: 1, marginLeft: 10 }}
              min={40}
              max={150}
              step={1}
              marks={{ 40: '40', 150: '150' }}
              tipFormatter={(value) => `${value}`}
              onAfterChange={this.bp2handleAfterChange}
              onChange={this.bp2handleSliderChange}
              value={this.state.bloodPressure[1]}
              trackStyle={{ backgroundColor: '#6c3964' }}
              activeDotStyle={{ borderColor: '#6c3964' }}
              tooltipVisible={this.state.bloodPressure2TooltipVisible}
            />
          </div>
        </Form.Item>




      


              {/* <Form.Item
                label="Blood Pressure"
                name="bloodPressure"
                rules={[{ required: true, message: 'Please input the blood pressure!' }]}
              > 
                <Input style={{width:"91%", marginLeft:"33px"}} />
              </Form.Item>*/}

              {/* <Form.Item
                label="Blood Oxygen"
                name="bloodOxygen"
                rules={[{ required: true, message: 'Please input the blood oxygen level!' }]}
              >
                <Input style={{width:"89%", marginLeft:"38px"}} />
              </Form.Item> */}
             


            <Form.Item>
            <Button onClick={() => this.setState({ showForm: false })} style={{marginRight:"10px"}}>Cancel</Button>
              <Button style={{backgroundColor:"#6c3964"}} type="primary" htmlType="submit" >
                Submit
              </Button>
             
            </Form.Item>
          </Form>
        </Modal>
      )} 
      <div className="row q-p-details -Token-Generator">
        {this.renderBody()}
      </div></div>
    );
  }
}
export default DoctorAndNurse;
